module.exports = __webpack_public_path__ + "static/img/user.4536df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/img/user.png
// module id = MSU2
// module chunks = 1